export const applyAdditionalCss = (
    documentType: 'pdf' | 'pptx',
    options: {
        size: string;
        orientation: string;
        width: number;
        height: number;
        margin: { top: number; left: number; bottom: number; right: number };
        bleed: { top: number; left: number; bottom: number; right: number };
        isRunningHeader: boolean | undefined;
        isRunningFooter: boolean | undefined;
    },
    additionalOpts?: { pdfPageSize?: string; pdfPageMargin?: any },
    originalOpts?: { originalSize?: string; originalMargin?: string }
) => {
    let pageSize = originalOpts?.originalSize;
    let pageMargin = originalOpts?.originalMargin;
    let pageBleed;

    if (options.size || options.orientation) {
        if (options.size === 'Custom') {
            pageSize = `${options.width}in ${options.height}in`;
        } else {
            pageSize = `${options.size} ${options.orientation}`;
        }
    } else if (additionalOpts?.pdfPageSize) {
        /**
         * @deprecated after orientation and pageSize introduced
         */
        pageSize = additionalOpts?.pdfPageSize;
    }

    if (options.margin) {
        const { top, left, bottom, right } = options.margin;
        pageMargin = `${top}in ${right}in ${bottom}in ${left}in`;
    } else if (additionalOpts?.pdfPageMargin) {
        /**
         * @deprecated after pageMargin introduced
         */
        pageMargin = additionalOpts?.pdfPageMargin;
    }

    if (options.bleed) {
        const { top, left, bottom, right } = options.bleed;
        pageBleed = `${top}in ${right}in ${bottom}in ${left}in`;
    }

    let additionalCss = `@page { `;

    if (documentType === 'pptx') {
        additionalCss += `
            // Page size
            size: ${pageSize};
            margin: ${pageMargin};
            bleed: ${pageBleed || 0};
        `;
    } else if (documentType === 'pdf') {
        additionalCss += `           
            // Page size
            size: ${pageSize};
            margin: ${pageMargin};
            bleed: ${pageBleed || 0};

            // Printer marks
            // https://www.pdfreactor.com/product/doc_html/index.html#PrinterMarks
            marks: crop;
        `;
    }

    if (options?.isRunningHeader) {
        additionalCss += `@top-center {
            content: element(running-header);  
            -ro-pdf-tag-type: 'Div';
        }`;
    }

    if (options?.isRunningFooter) {
        additionalCss += `@bottom-center {
            content: element(running-footer);
            -ro-pdf-tag-type: 'Div';
        }`;
    }

    additionalCss += '}';

    if (options?.isRunningHeader) {
        additionalCss += `.running-header {
            position: running(running-header);
        } `;
    }

    if (options?.isRunningFooter) {
        additionalCss += `.running-footer {
            position: running(running-footer);
        } `;
    }

    return additionalCss;
};
